import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import useAPI from "../../../../../../api/hooks/useAPI";
import { ComplexEntityTypes } from "../../../../../../utils/constants";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import { useEntities } from "../../../hooks/useEntities";
import EntityDrawer from "../../EntityDrawer/EntityDrawer";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import { getUserRelatedTokensRows } from "./checkRowsUserData";

const UserRelatedTokensView = ({ entityData }) => {
  const [rows, setRows] = useState([]);
  const { useQueryForEntitiesByType } = useEntities();

  const { trackEvent } = useAPI();
  const [isTokenDrawerOpen, setIsTokenDrawerOpen] = useState(false);
  const [clickedTokenEntity, setClickedTokenEntity] = useState(null);

  const onTokenClick = (cellParams) => {
    trackEvent(
      `User clicked on Token ID ${cellParams?.row?.tokenId}, from user related tokens view ${entityData?.display_name}`
    );
    setIsTokenDrawerOpen(true);
    setClickedTokenEntity(cellParams?.row?.entityObj);
  };

  const { data: nonhumanIdentityEntities } = useQueryForEntitiesByType({
    type: ComplexEntityTypes.NONHUMAN_IDENTITY,
  });

  useEffect(() => {
    setRows(getUserRelatedTokensRows(entityData, nonhumanIdentityEntities));
  }, [entityData, nonhumanIdentityEntities]);

  return (
    rows.length > 0 && (
      <Box display={"flex"} flexDirection={"column"} gap={1}>
        {rows.map((row) => (
          <TextIntegrationStyle
            title={
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                gap={1}
              >
                {row.source.map((source, index) => (
                  <IntegrationImage
                    key={index}
                    name={source}
                    width={"16px"}
                    newLogo={true}
                  />
                ))}
              </Box>
            }
            value={row?.entityObj?.display_name}
            onClick={() => onTokenClick({ row })}
            style={{
              cursor: "pointer",
              textDecoration: "underline",
            }}
            tooltipTitle={"Click to view token details"}
          ></TextIntegrationStyle>
        ))}

        <EntityDrawer
          openDrawer={isTokenDrawerOpen && clickedTokenEntity}
          selectedEntity={clickedTokenEntity}
          onClose={() => {
            setIsTokenDrawerOpen(false);
          }}
        />
      </Box>
    )
  );
};

export default UserRelatedTokensView;
